import React, { useCallback, useState, useContext } from 'react';

import { SnackbarProvider } from 'notistack';
import Button from '@material-ui/core/Button';
import Close from '@material-ui/icons/Close';

import AlertMsg from '../components/AlertMsg';

const SnackbarContext = React.createContext({});

const notistackRef = React.createRef();
const onClickDismiss = key => () => { notistackRef.current.closeSnackbar(key); }

const AlertMsgProvider = ({ children }) => {
    const [ barProps, setBarProps ] = useState({});


    const addSnackBar = useCallback(
        ({ message, info, open  }) => {
            
            setBarProps({
                message,
                info,
                open
            })
        }
    )

    return (
        <SnackbarContext.Provider value={{ addSnackBar }}>
            { children }
            <SnackbarProvider maxSnack={10}  ref={notistackRef} action={(key) => (<Button onClick={onClickDismiss(key)}><Close /></Button>)}>
                <AlertMsg 
                    successSnackbarMessage={barProps.message}
                    successSnackbarOpen={barProps.open}
                    successSnackbarInfo={barProps.info}
                    
                />
            </SnackbarProvider>
        </SnackbarContext.Provider>
    )
}

function useSnackBar() {
    const context = useContext(SnackbarContext);
    
    if (!context) {
        throw new Error('Erro ao usar snackbar');
    }

    return context;
}

export { AlertMsgProvider, useSnackBar };